'use client';

import ChevronLeft from '@hc-frontend/core-icons/kit/chevron-left';
import ChevronRight from '@hc-frontend/core-icons/kit/chevron-right';

import { Reel } from '../reel/reel';
import { handleScroll, scrollLeft, scrollRight } from './carrousel.handlers';
import type { CarrouselProps } from './carrousel.types';

export function Carrousel({ children }: CarrouselProps) {
  // Be careful with the orders as the handlers depends on the position of the elements
  return (
    <div className="relative">
      <button
        type="button"
        className="hc-typography--title-case-sm absolute left-0 top-[calc(50%-1em/2)] z-10 rounded-full bg-tertiary-900 text-gray-0"
        onClick={scrollLeft}
        data-testid="scroll-left"
        aria-label="scroll left"
      >
        <ChevronLeft viewBox="0 0 24 24" />
      </button>
      <button
        type="button"
        className="hc-typography--title-case-sm absolute right-0 top-[calc(50%-1em/2)] z-10 rounded-full bg-tertiary-900 text-gray-0"
        onClick={scrollRight}
        data-testid="scroll-right"
        aria-label="scroll right"
      >
        <ChevronRight viewBox="0 0 24 24" />
      </button>
      <div className="px-[calc(var(--font-size-title-case-sm)/3)]">
        <Reel
          className="hc-scrollbar--hidden [&_>_*_]:w-full [&_>_*_]:tablet:w-[calc((100%-2*var(--hc-reel-layout-space))/3)] [&_>_.mark]:[animation:pulse_0.5s_cubic-bezier(0.4,0,0.6,1)]"
          onScroll={handleScroll}
        >
          {children}
        </Reel>
      </div>
    </div>
  );
}
